import { RootState } from "../../../types/redux-types";

export const getGenericModal = (state: RootState) => state.modals.genericModal;
